module.exports = __webpack_public_path__ + "img/motor_no59.6ed4cfc3.jpg";